import { render, staticRenderFns } from "./APPIndexPlaceholder.vue?vue&type=template&id=86d36730&scoped=true&"
import script from "./APPIndexPlaceholder.vue?vue&type=script&lang=ts&"
export * from "./APPIndexPlaceholder.vue?vue&type=script&lang=ts&"
import style0 from "./APPIndexPlaceholder.vue?vue&type=style&index=0&id=86d36730&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86d36730",
  null
  
)

export default component.exports